export class CacheKeys {
	static readonly APPROVAL_COOKIES_INFO = "_APPROVAL_COOKIES_INFO";
	static readonly IMPERSONATION = "_IMPERSONATION";
	static readonly QUESTIONS_FORM_SHOW_MODAL = "_GLOBAL_QUESTIONS_FORM_SHOW_MODAL";
	static readonly RENTAL_SWITCHER_SELECTION = "_RENTAL_SWITCHER_SELECTION";
	static readonly SUM_UP_MODE = "_SUM_UP_MODE";
	static readonly USER_CONNECTION = "_USER_CONNECTION";
}
